import PrizePageSwitchboard from '.';

export default PrizePageSwitchboard;
